export const theme = {
	colors: {
		primary: '#007bff',
		secondary: '#6c757d',
		success: '#28a745',
		purple: '#652D86',
		red: '#EE255C',
		cerulean_blue: '#1D8DE1',
		black: '#111114',
		brown: 'rgba(17, 17, 20, 0.64)',
		black_2 : 'rgba(17, 17, 20, 0.02)',
		black_4 : 'rgba(17, 17, 20, 0.04)',
		black_6 : 'rgba(17, 17, 20, 0.06)',
		black_8 : 'rgba(17, 17, 20, 0.08)',
		black_48 : 'rgba(17, 17, 20, 0.48)',
	},
	fonts: {
		primary: 'Inter, sans-serif',
	},
};
